import {
  Box,
  Button,
  Divider,
  Menu,
  Paper,
  Popover,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  DatePicker,
  LocalizationProvider,
  StaticDatePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DatesPicker from "components/general/DatesPicker";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { DateRangePicker } from "mui-daterange-picker";
import moment from "moment";
import { useAppDispatch } from "store/appHooks";
import { handleSnackBar } from "slices/global";

const DateSelectionPopover = ({
  id,
  anchorEl,
  handleClose,
  onChange,
}: // open,
{
  id?: any;
  anchorEl?: any;
  handleClose?: any;
  onChange: any;
  // open?: any;
}) => {
  const theme = useTheme();
  const [value, setValue] = useState<any>([]);
  const [open, setOpen] = useState<any>(true);
  const dispatch = useAppDispatch();

  const checkDiff = (ds: any) => {
    const diff = moment(moment(ds.end).format("yyyy-MM-DD")).diff(
      moment(ds.start).format("yyyy-MM-DD"),
      "days"
    );

    if (diff < 1) {
      dispatch(
        handleSnackBar({
          open: true,
          message: "Start and End date cannot be same",
          severity: "error",
        })
      );
      return false;
    }
    return true;
  };

  const matchesSm = useMediaQuery(theme.breakpoints.down("sm"));
  const matchesXs = useMediaQuery(theme.breakpoints.only("xs"));

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          ".css-1tehbvn-MuiPaper-root": {
            boxShadow: "none",
          },
          ...(matchesSm || matchesXs
            ? {
                ".css-1j13ek9-MuiGrid-root": {
                  display: "flex",
                  flexWrap: "wrap",
                  padding: "10px",

                  width: "333px",
                },
                ".css-6hp17o-MuiList-root-MuiMenu-list": {
                  width: "300px",
                },
                ".css-1vism8w-MuiGrid-root": {
                  display: "flex",
                  flexWrap: "wrap",
                },
                ".css-1tk1bks-MuiDivider-root": {
                  display: "none",
                },
              }
            : {}),
        }}
      >
        <DateRangePicker
          open={open}
          toggle={() => {
            if (value.length && checkDiff(value)) {
              onChange(value);
              setOpen(!open);
              handleClose();
            } else {
              setOpen(!open);
              handleClose();
            }
          }}
          onChange={(range) => {
            if (
              checkDiff({
                start: range?.startDate || null,
                end: range?.endDate || null,
              })
            ) {
              setValue({
                start: range?.startDate || null,
                end: range?.endDate || null,
              });
            }
          }}
          definedRanges={[]}
        />
      </Box>
      <Divider />
      <Box
        sx={{
          mx: 2,
          my: 2,
          float: "center",
          display: "flex",
          gap: "10px",
          justifyContent: "flex-end",
        }}
      >
        <Button
          variant="outlined"
          onClick={() => {
            setOpen(!open);
            onChange([]);
            handleClose();
          }}
          sx={{ borderRadius: "10px" }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            if (checkDiff(value)) {
              setOpen(!open);
              onChange(value);
              handleClose();
            }
          }}
          sx={{ borderRadius: "10px" }}
        >
          Apply Dates
        </Button>
      </Box>
    </Box>
  );
};

export default DateSelectionPopover;
